import { Component, Input, type OnChanges, type OnInit, type SimpleChanges, inject } from '@angular/core';
import { FormBuilder, type FormGroup } from '@angular/forms';

import { type AuditRecord } from '../../models/common.models';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-audit',
  standalone: false,
  templateUrl: './audit.component.html',
  styleUrl: './audit.component.scss'
})
export class AuditComponent implements OnInit, OnChanges {
  private fb = inject(FormBuilder);
  private sharedService = inject(SharedService);

  @Input() data: AuditRecord | undefined;
  form!: FormGroup;
  private latestData?: AuditRecord;

  ngOnInit(): void {
    this.form = this.fb.group({
      createdByName: [''],
      createdDate: [''],
      lastModifiedByName: [''],
      lastModifiedDate: ['']
    });

    this.patchForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue) {
      this.latestData = changes['data'].currentValue;
      this.patchForm();
    }
  }

  private patchForm(): void {
    if (!this.form || !this.latestData) {
      return;
    }

    this.form.patchValue({
      ...this.latestData,
      createdDate: this.sharedService.formatDate(this.latestData.createdDate),
      lastModifiedDate: this.sharedService.formatDate(this.latestData.lastModifiedDate)
    });
  }
}
